import $ from 'jquery';
import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
import PropTypes from 'prop-types';
import React from 'react';
import Frame from 'react-frame-component';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import AuthService from '../services/AuthService';

class ContractTermsDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new AuthService());
        this.state = {readTerms: false};
        this.renderFooter = this.renderFooter.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        super.componentDidMount();
    }

    getContainerListName() {
        return 'contract-terms-container';
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton
                    disabled={!this.state.readTerms}
                    label={t('contract-terms.agree')}
                    variant='button save-button fullred'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 contract-terms-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`contract-terms-header-label-id`}>{this.props.contractTerms.name}</label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        const {t, contractTerms, contractTermsToken} = this.props;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.authService
                .acceptTerms(contractTerms.contractTermsId, contractTermsToken)
                .then((response) => {
                    this.blockUi();
                    if (this.props.afterSave) {
                        this.persistMessage('success', '', t('cards.successAuthorize'));
                        this.props.afterSave();
                    }
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.afterSave) {
                        this.persistMessage('error', '', t('error.errorAuthorize'));
                        this.props.afterSave();
                    }
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError();
                    }
                });
        }
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
            this.setState({readTerms: true});
        }
    };

    render() {
        const {className, id, key, name, onHide, visible, style} = this.props;
        return (
            <Dialog
                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                header={this.renderHeader()}
                visible={visible}
                className={className}
                style={style}
                key={`${key ? key : id ? id : name}-dialog`}
                onHide={() => (onHide ? onHide() : null)}
                closable={this.state.closable}
            >
                {this.state.loading ? null : (
                    <Card footer={this.renderFooter()}>
                        <form onSubmit={this.handleFormSubmit} noValidate onKeyDown={(e) => this.onKeyDown(e)} onScroll={this.handleScroll}>
                            {this.renderDetails()}
                        </form>
                    </Card>
                )}
            </Dialog>
        );
    }

    renderDetails() {
        return (
            <Frame
                ref={this.iframeRef}
                onScroll={this.handleScroll}
                className='contract-terms-container'
                id='contract-terms-id'
                initialContent={this.props.contractTerms.content}
                contentDidMount={() => {
                    $('#contract-terms-id').width('100%');
                    $('#contract-terms-id').height(this.iframeRef.current.contentWindow.document.body.scrollHeight);
                    $('#contract-terms-id').contents().find('html').css({
                        'overflow-y': 'hidden',
                    });
                }}
            ></Frame>
            // <div >
            //     <span dangerouslySetInnerHTML={{__html: this.props.contractTerms.content}} />
            // </div>
        );
    }
}

ContractTermsDialog.defaultProps = {
    viewMode: 'VIEW',
};

ContractTermsDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
};

export default withTranslation()(ContractTermsDialog);
